import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { LandUseStatusDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
@Component({
  selector: 'cradua-land-use-status-container',
  templateUrl: './land-use-status-container.component.html',
  styleUrls: ['./land-use-status-container.component.scss']
})
export class LandUseStatusContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  landusestatuss$: Observable<LandUseStatusDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("LandUseStatus");
    this.landusestatuss$ = this.gatwayFacade.loadGateway("LandUseStatus");
    this.landusestatuss$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteLandUseStatus(deletedValue: any) {
    this.gatwayFacade.remove("LandUseStatus", deletedValue);
    // this.store.dispatch(LandUseStatusStoreActions.removeLandUseStatus({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitLandUseStatus(formValue: any) {
    console.log("form value: ", formValue);
    formValue.LandUseStatuss = formValue.LandUseStatuss.reverse();
    event.preventDefault();
    const pullData = formValue.LandUseStatuss;
    //const newPullData = formValue.LandUseStatuses;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllLandUseStatus = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllLandUseStatus.push(pullData[i]);
    }
  }

// check if the addAllLandUseStatus array is not empty, then dispatch the data to the store
   if(addAllLandUseStatus.length !== 0) {
    this.gatwayFacade.add('LandUseStatus', addAllLandUseStatus);
    // this.store.dispatch(LandUseStatusStoreActions.addLandUseStatus({newLandUseStatus: addAllLandUseStatus}));

   }

// dispatch update data to the store
this.gatwayFacade.update('LandUseStatus', allUpdates, ['id']);
    // this.store.dispatch(LandUseStatusStoreActions.updateLandUseStatus({updateLandUseStatus: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}



